import { Icon, InputAdornment } from '@mui/material';
import React, { useState } from 'react';
import { RootStyled } from './inputlabelPassword.styles';

export default function InputLabel(props) {
  const [showPassword, setShowPassword] = useState(false);
  return (
    <RootStyled
      {...props}
      variant="outlined"
      type={showPassword ? 'text' : 'password'}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <Icon onClick={() => setShowPassword(!showPassword)}>
              {showPassword ? 'visibility' : 'visibility_off'}
            </Icon>
          </InputAdornment>
        ),
      }}
    />
  );
}
